import * as angular from 'angular';
import * as _ from 'lodash';

import { guidEmpty, groupForbiddenCharacters, groupForbiddenStartingCharacters } from '../../../common';
import { Group } from '../../../models/entities/Group';
import { Template, ComponentDefinition } from '../../../models';
import { ILoggerService, ITemplateService } from '../../../services';
import { TemplateCreationProperties } from '../../../stateManagement';

interface ItemplateFormCtrl extends angular.IFormController {
    templateName: angular.INgModelController;
}

class TemplateGroupModalContoller implements angular.IComponentController {
    comment: string;
    formCtrl: ItemplateFormCtrl;
    group: Group;
    guidEmpty = guidEmpty;
    includeChildren: boolean;
    modalId: string;
    templateName: string;

    readonly createTemplate: (value: { config: TemplateCreationProperties }) => angular.IPromise<Template>;
    readonly templates: Template[];

    static $inject = ['$scope', '$timeout'];

    constructor(
        private _$scope: angular.IScope,
        private _$timeout: angular.ITimeoutService
    ) {
    }

    $onInit() {
        this._$timeout(() => this.initModalEvent());
    }

    createFrom() {
        const configuration = {
            config: {
                name: this.templateName,
                comment: this.comment,
                groupGuid: this.group.guid,
                includeChildren: this.includeChildren
            }
        };
        this.createTemplate(configuration);
    }

    validateName() {
        this.checkForbidden();
        this.checkDuplicate();
    }

    private initModalEvent() {
        angular.element(`#${this.modalId}`).on('hidden.bs.modal', () => {
            this.templateName = '';
            this.formCtrl.$setPristine();
            this._$scope.$apply();
        });
    }

    private checkForbidden() {
        const newName = this.formCtrl.templateName.$viewValue.toLowerCase();
        const isValid = !_.some(newName, c => groupForbiddenCharacters.indexOf(String(c)) >= 0) &&
            !_.some(groupForbiddenStartingCharacters, c => _.startsWith(newName, c));

        this.formCtrl.templateName.$setValidity('forbidden', isValid);
    }

    private checkDuplicate() {
        const isValid = !_.some(this.templates, t => t.name.toLowerCase() === this.formCtrl.templateName.$viewValue.toLowerCase());
        this.formCtrl.templateName.$setValidity('duplicate', isValid);
    }
}

export const wtTemplateGroupModal: ComponentDefinition = {
    componentId: 'wtTemplateGroupModal',
    template: require('./templateGroupModal.component.html'),
    controller: TemplateGroupModalContoller,
    controllerAs: 'vm',
    bindings: {
        createTemplate: '&?',
        group: '<',
        modalId: '@',
        templates: '<'
    }
};